import { RouterProvider, Toast } from '@heroui/react';
import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { AuthInitializer } from './AuthInitializer';
import { AdminRoute } from './components/AdminRoute';
import { PublicLayout } from './components/PublicLayout';
import { UmamiIdentify } from './components/UmamiIdentify';

const AdminLeadsPage = React.lazy(() => import('./pages/admin/LeadsPage'));
const AdminUsersPage = React.lazy(() => import('./pages/admin/UsersPage'));
const AudienceRecommendationInsightsPage = React.lazy(() => import('./pages/AudienceRecommendationInsightsPage'));
const PersonaAudiencesPage = React.lazy(() => import('./pages/audienceCatalog/PersonaAudiencesPage'));
const CategoryAudiencesPage = React.lazy(() => import('./pages/audienceCatalog/CategoryAudiencesPage'));
const GetAccessPage = React.lazy(() => import('./pages/GetAccessPage'));
const AppHomePage = React.lazy(() => import('./pages/AppHomePage'));
const LandingPage = React.lazy(() => import('./pages/LandingPage'));
const LogoutPage = React.lazy(() => import('./pages/LogoutPage'));
const PrivacyPage = React.lazy(() => import('./pages/PrivacyPage'));

function AppRouter() {
    const navigate = useNavigate();
    return (
        <RouterProvider navigate={navigate}>
            <UmamiIdentify />
            <Toast.Provider placement="top end" />
            <Suspense fallback={null}>
                <Routes>
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/get-access" element={<GetAccessPage />} />
                        <Route path="/website-privacy-notice" element={<PrivacyPage />} />
                    </Route>
                    <Route
                        path="/app/*"
                        element={
                            <AuthInitializer>
                                <Suspense fallback={null}>
                                    <Routes>
                                        <Route path="logout" element={<LogoutPage />} />
                                        <Route
                                            path="audience-recommendation-insights/:recommendationId"
                                            element={<AudienceRecommendationInsightsPage />}
                                        />
                                        <Route path="persona-audiences" element={<PersonaAudiencesPage />} />
                                        <Route path="category-audiences" element={<CategoryAudiencesPage />} />
                                        <Route element={<AdminRoute />}>
                                            <Route path="admin/leads" element={<AdminLeadsPage />} />
                                            <Route path="admin/users" element={<AdminUsersPage />} />
                                        </Route>
                                        <Route path="*" element={<AppHomePage />} />
                                    </Routes>
                                </Suspense>
                            </AuthInitializer>
                        }
                    />
                    <Route path="*" element={<Navigate replace to="/app" />} />
                </Routes>
            </Suspense>
        </RouterProvider>
    );
}

export { AppRouter };
